import React from 'react';
import Table from '../../../../components/generic/table/Table';
import { Field, formValueSelector } from 'redux-form';
import { TableButton } from '../../../../styles/BasicStyles';
import { Popconfirm, Icon, Row } from 'antd';
import TextInput from '../../../../components/generic/inputs/TextInput';
import NumberInput from '../../../../components/generic/inputs/NumberInput';
import BaseButton from '../../../../components/generic/buttons/BaseButton';
import { connect } from 'react-redux';

let FurnituresTable = ({ fields, objectName, furnitures }) => {
  const columns = [
    {
      title: 'Referência',
      dataIndex: 'reference',
      render: (value, item, index) => (
        <Field
          component={TextInput}
          type="text"
          name={`${objectName}[${index}].reference`}
        />
      )
    },
    {
      title: 'Descrição',
      dataIndex: 'description',
      render: (value, item, index) => (
        <Field
          component={TextInput}
          type="text"
          name={`${objectName}[${index}].description`}
        />
      )
    },
    {
      title: 'Quantidade',
      dataIndex: 'quantity',
      render: (value, item, index) => (
        <Field
          component={NumberInput}
          name={`${objectName}[${index}].quantity`}
        />
      )
    },
    {
      title: 'Operações',
      render: (value, item, index) => (
        <React.Fragment>
          <TableButton error onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              placement="topRight"
              title="Tem a certeza que quer remover o móvel?"
              onConfirm={() => fields.remove(index)}
            >
              <Icon style={{ marginRight: 10 }} type="delete" />
              {'Remover'}
            </Popconfirm>
          </TableButton>
        </React.Fragment>
      )
    }
  ];

  return (
    <>
      <Row style={{ marginTop: '25px', marginBottom: '10px' }}>
        <BaseButton
          type="default"
          icon="plus"
          text="Adicionar campo"
          onClick={() => {
            if (
              furnitures.length < 10 &&
              (furnitures.length === 0 ||
                (furnitures.length > 0 && furnitures[0].reference !== ''))
            ) {
              fields.unshift({ reference: '' });
            }
          }}
        />
      </Row>
      <Row>
        <Table
          columns={columns}
          currentPage={1}
          pageSize={furnitures.length}
          loading={false}
          rows={furnitures}
          showHeader={true}
          emptyIcon="solution"
          emptyText={'Não existe nenhum móvel'}
          total={furnitures.length}
          rowKey={(record, index) => index}
        />
      </Row>
    </>
  );
};

const selector = formValueSelector('manage_events_form');

FurnituresTable = connect((state) => {
  const { furnitures } = selector(state, 'hasFurniture', 'furnitures');
  return {
    furnitures
  };
})(FurnituresTable);

export default FurnituresTable;
